<template>
    <div class="row">
        <div class="col-md-6">
            <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
                <div class="panel panel-primary heading-border">
                    <div class="panel-heading">
                        <span class="panel-title">
                            <i class="fa fa-pencil-square"></i>
                            <span v-if="trainer.id">Редактирование инструктора</span>
                            <span v-else>Добавление инструктора</span>
                        </span>
                    </div>
                    <form @submit.prevent="submit">
                        <div class="panel-body p25">

                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Фамилия</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.trainer.lastName.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-user"></i></label>
                                    </label>
                                    <div v-if="$v.trainer.lastName.$error === true || forms.trainer.errors.last_name" class="error">
                                        {{ this.forms.trainer.errors.last_name ? this.forms.trainer.errors.last_name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Имя</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.trainer.firstName.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-user"></i></label>
                                    </label>
                                    <div v-if="$v.trainer.firstName.$error === true || forms.trainer.errors.first_name" class="error">
                                        {{ this.forms.trainer.errors.first_name ? this.forms.trainer.errors.first_name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class=" section row">

                                <div class="col-md-6">
                                    <label class="switch switch-primary">
                                        <input type="checkbox" id="form-trainer-is-archive" v-model="$v.trainer.isArchive.$model" value="1">
                                        <label for="form-trainer-is-archive" data-on="Да" data-off="Нет"></label>
                                        <span>Архивный</span>
                                    </label>
                                </div>
                                <div class="col-md-6">
                                    <label class="switch switch-primary">
                                        <input type="checkbox" id="form-trainer-is-show-site" v-model="$v.trainer.isShowSite.$model" value="1">
                                        <label for="form-trainer-is-show-site" data-on="Да" data-off="Нет"></label>
                                        <span>Отображать на сайте</span>
                                    </label>
                                </div>
                            </div>

                            <div class="section row mb25">
                                <div class="col-md-12">
                                    <label class="field-label">Описание</label>
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" v-model="$v.trainer.content.$model"></textarea>
                                        <label class="field-icon">
                                            <i class="fa fa-edit"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary" :disabled="forms.trainer.isSubmitting">
                                <span v-if="trainer.id">Сохранить</span>
                                <span v-else>Добавить</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row">
                <div class="panel" v-if="trainer.id">
                    <div class="panel-heading">
                        <span class="panel-title">Фото</span>
                        <span class="panel-controls"></span>
                    </div>
                    <form>
                        <div class="panel-body" v-if="trainer.image">
                            <div class="col-md-6 center-block text-center">
                                <img :src="trainer.image.image" style="max-width: 100%;">
                            </div>
                        </div>
                        <div class="panel-menu">
                            <div v-if="Object.keys(forms.image.errors).length > 0" class="error pb10">
                                {{ this.forms.image.errors.image.join(', ') }}
                            </div>
                            <label class="btn btn-primary mr10" :disabled="forms.image.isSubmitting">
                                <input type="file" class="hidden" v-on:change="saveImage">
                                <span class="glyphicon glyphicon-upload"></span>
                                Загрузить
                            </label>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Trainer from "../../models/Trainer";
    import ValidationError from "../../classes/ValidationError";
    import { required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';

    export default {
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {
            if (to.params.id) {
                try {
                    const trainer = await Trainer.get(to.params.id);
                    next(component => {
                        component.trainer = trainer;
                    });
                } catch (error) {
                    next({
                        name: 'error',
                        path: to.fullPath,
                        params: {
                            code: error.response.status,
                            codeText: error.response.statusText,
                            message: error.response.data.message,
                            trace: error.response.data.type,
                        },
                    })
                }
            } else {
                next(component => {
                    Object.assign(component.$data, component.$options.data.apply(component));
                });
            }
        },
        data() {
            return {
                trainer: new Trainer({
                    status: Trainer.STATUS_ACTIVE,
                }),
                forms: {
                    trainer: {
                        isSubmitting: false,
                        errors: {},
                    },
                    image: {
                        isSubmitting: false,
                        upload: null,
                        errors: {},
                    },
                },
            };
        },
        validations: {
            trainer: {
                firstName: {required},
                lastName: {required},
                content: {},
                isArchive: {},
                isShowSite: {},
            },
        },
        methods: {
            async submit() {
                this.$v.trainer.$touch();
                if (this.$v.$invalid) {
                    return false;
                }

                this.forms.trainer.isSubmitting = true;
                this.forms.trainer.errors = {};


                if (this.trainer.id) {

                    try {
                        await this.trainer.update();
                    } catch (error) {
                        this.forms.trainer.errors = error.errors;
                    }

                } else {

                    try {
                        this.trainer = await this.trainer.add();

                        await this.$router.push({name: 'trainers-edit', params: {id: this.trainer.id}});
                    } catch (error) {
                        this.forms.user.errors = error.errors;
                    }

                }

                this.forms.trainer.isSubmitting = false;
            },
            async saveImage(event) {
                this.forms.image.errors = {};
                this.forms.image.isSubmitting = true;
                const image = event.target.files[0];

                try {
                    await this.trainer.updateImage(image);
                } catch (error) {
                    if (error instanceof ValidationError) {
                        this.forms.image.errors = error.errors;
                    } else {
                        this.$notify({
                            type: 'error',
                            position: 'top middle',
                            text: 'Ошибка загрузки изображения'
                        });
                    }
                }

                this.forms.image.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Инструкторы - ' + (this.trainer.id ? 'редактирование' : 'добавление'),
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>